import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Grid,
  Tooltip,
  Fade
} from '@mui/material';
import axios from 'src/utils/axios';
import { Fab } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

// Modern stil tanımları
const styles = {
  deleteButton: {
    backgroundColor: '#fee2e2',
    color: '#dc2626',
    boxShadow: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#fecaca',
      boxShadow: '0 4px 12px rgba(220, 38, 38, 0.2)',
      transform: 'scale(1.05)',
    },
    '&:disabled': {
      backgroundColor: '#f3f4f6',
      color: '#9ca3af',
    },
  },
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      overflow: 'hidden',
    },
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    color: '#ffffff',
    padding: '20px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  titleIcon: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '12px',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogContent: {
    padding: '32px 24px',
    backgroundColor: '#ffffff',
    textAlign: 'center',
  },
  warningIcon: {
    fontSize: '64px',
    color: '#f59e0b',
    marginBottom: '16px',
  },
  dialogText: {
    color: '#475569',
    fontSize: '1rem',
    lineHeight: 1.6,
    marginBottom: '8px',
  },
  fisNoChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#fef3c7',
    color: '#b45309',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: 600,
    marginTop: '12px',
  },
  dialogActions: {
    padding: '16px 24px 24px',
    backgroundColor: '#f8fafc',
    borderTop: '1px solid #e2e8f0',
    gap: '12px',
    justifyContent: 'center',
  },
  confirmButton: {
    borderRadius: '12px',
    padding: '12px 32px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    backgroundColor: 'transparent',
    border: '2px solid #f59e0b',
    color: '#1f2937',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(245, 158, 11, 0.08)',
      border: '2px solid #d97706',
      boxShadow: 'none',
    },
  },
  cancelButton: {
    borderRadius: '12px',
    padding: '12px 32px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    borderColor: '#e2e8f0',
    color: '#64748b',
    '&:hover': {
      backgroundColor: '#f1f5f9',
      borderColor: '#cbd5e1',
    },
  },
};

function ReceiptCancelButton(props) {
  const [open, setOpen] = React.useState(false);
  const { data } = props;
  const { setData } = props;
  const { FisNo } = props;
  const { cancelledReceipts } = props;
  const { setCancelledReceipts } = props;

  const isDisabled = cancelledReceipts.filter(x => x.FisNo === FisNo).length > 0 || 
                     data?.Receipts?.find(x => x.FisNo === FisNo)?.AcikKapali === 1;

  const handleClose = () => {
    setOpen(false);
  };

  const cancelReceipt = () => {
    setCancelledReceipts(prevData => [
      ...prevData, 
      { FisNo }
    ]);
    console.log(cancelledReceipts);
    setOpen(false);
  };

  return (
    <>
      <Grid item xs={1}>
        <Tooltip 
          title={isDisabled ? "Bu fiş iptal edilemez" : "Fişi İptal Et"} 
          arrow
          placement="top"
        >
          <span>
            <Fab
              size="small"
              aria-label="Sil"
              disabled={isDisabled}
              onClick={() => setOpen(true)}
              sx={styles.deleteButton}
            >
              <DeleteIcon fontSize="small" />
            </Fab>
          </span>
        </Tooltip>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        sx={styles.dialog}
        TransitionComponent={Fade}
        transitionDuration={300}
      >
        <DialogTitle sx={styles.dialogTitle}>
          <Box sx={styles.titleIcon}>
            <ReceiptLongIcon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Fiş İptali
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9, fontSize: '0.8rem' }}>
              Bu işlem geri alınamaz
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={styles.dialogContent}>
          <WarningAmberIcon sx={styles.warningIcon} />
          <Typography sx={styles.dialogText}>
            Bu fişi iptal etmek istediğinize emin misiniz?
          </Typography>
          <Box sx={styles.fisNoChip}>
            <ReceiptLongIcon sx={{ fontSize: '18px' }} />
            Fiş No: {FisNo}
          </Box>
        </DialogContent>

        <DialogActions sx={styles.dialogActions}>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={styles.cancelButton}
            startIcon={<CloseIcon />}
          >
            Hayır, Vazgeç
          </Button>
          <Button
            variant="outlined"
            onClick={cancelReceipt}
            sx={styles.confirmButton}
            endIcon={<CheckIcon sx={{ color: '#f59e0b' }} />}
          >
            Evet, İptal Et
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ReceiptCancelButton;
